"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArtifactVersion = void 0;
var get_artifact_version_1 = require("./get-artifact-version");
Object.defineProperty(exports, "getArtifactVersion", { enumerable: true, get: function () { return get_artifact_version_1.getArtifactVersion; } });
//# sourceMappingURL=index.js.map